module.exports = function () {
    $(document).ready(function () {

        let defaultDate,
            dateTimeFormat = 'YYYY-MM-DD H:mm',
            inputValue = $('input[name="date_notice"]').val();

        if (inputValue === "") {
            defaultDate = new Date();
            defaultDate.setDate(defaultDate.getDate() + 28);
        }
        else {
            defaultDate = inputValue;
        }

        function updateInput(date) {
            $('input[name="date_notice"]').val(date)
        }

        $(function() {
            $('.ntq-delete').on('click', function () {
                let form = $('form');

                form.attr('action', this.getAttribute('data-url'));
                $('input[name="_method"]').val('DELETE');

                form.first().submit();
            });

            $('#datetimepicker').datetimepicker({
                defaultDate: defaultDate,
                format: dateTimeFormat,
                inline: true,
                sideBySide: true,
            }).on('dp.change', function(event) {
                updateInput(event.date.format(dateTimeFormat));
            });
            updateInput($('#datetimepicker').data('date'));
        });
    });
}();
